import { ca } from '@cian/analytics';

export const trackPubAvailPopupAction = (action: string, label: string) => {
  ca('event', {
    name: 'oldevent',
    category: 'PopupRentAlert',
    action,
    label,
  });
};
